// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__LALt5","label":"SetPasswdForm_label___xRkH"};